export class Review {
    constructor(review) {
        this.id      = review.id;
        this.content = review.content;
        this.status  = review.status ? review.status : 1; //0: deleted, 1: not update, 2: updated, 3: new added
    }
    changeStatus(status) {
        this.status = status;
    }

    updateContent(content) {
        this.content = content;
    }
}